import api from "!../../../.yarn/__virtual__/style-loader-virtual-203650cb13/0/cache/style-loader-npm-2.0.0-b9a5c4a2aa-21425246a5.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../.yarn/__virtual__/css-loader-virtual-31c1e966a2/0/cache/css-loader-npm-5.2.7-e1e8b8d16f-fb0742b30a.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../.yarn/__virtual__/postcss-loader-virtual-78460824b9/0/cache/postcss-loader-npm-5.3.0-8ac0151e96-15b8b79aca.zip/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./common.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};